export default "__VITE_ASSET__C$q6rXTH__"